/**
 * Utility functions for transforming WebSocket responses
 */

/**
 * Ensures response has the correct structure with result field
 */
export const ensureResultField = (
  transformedResponse: any,
  responseData?: any
): any => {
  let data = responseData || transformedResponse.data || transformedResponse;
  
  // CRITICAL: Ensure result field exists - check transformedResponse first, then medication_data
  if (!data.result && transformedResponse.data?.medication_data) {
    data = {
      ...data,
      result: transformedResponse.data.medication_data
    };
  } else if (!data.result && data.medication_data) {
    data = {
      ...data,
      result: data.medication_data
    };
  } else if (!data.result) {
    data = {
      ...data,
      result: [],
      medication_data: []
    };
  }
  
  // Ensure we preserve ALL fields from transformedResponse.data
  return {
    ...transformedResponse,
    data: {
      ...transformedResponse.data, // Preserve all original fields (response, validation, etc.)
      ...data, // Override with our ensured result field
      result: data.result || transformedResponse.data?.result || transformedResponse.data?.medication_data || [] // Final guarantee
    }
  };
};

